import React from "react";
import { TabsProps } from "./props";

function Tabs({ tabs, activeId, onClick }: TabsProps) {
  const getClassName = (id: string) => {
    return (
      "vcl-tab-nav-item " +
      (activeId === id
        ? "vcl-tab-nav-item-active"
        : "vcl-tab-nav-item-inactive")
    );
  };
  return (
    <div className="vcl-tab-nav">
      {tabs.map((tab) => (
        <div
          key={`${tab.id}-tab`}
          className={getClassName(tab.id)}
          onClick={() => {
            onClick(tab.id);
          }}
        >
          {tab.name}
        </div>
      ))}
    </div>
  );
}

export default Tabs;
